<template>
  <w-card tile class="fill-width initiative-card">
    <template #title>
      <w-toolbar>
          <div class="title3">
            <router-link v-bind:to="'/initiative/' + initiative.initiativeId"  style="color:black;">
              {{ initiative.title }}
            </router-link>
          </div>
          <div class="spacer ml3"></div>
          <w-progress
            v-model="scoreCopy"
            size="5em"
            circle
            color="success"
            label
            label-color="black"
            class="no-shrink">
            <strong>{{ Math.round(scoreCopy) }}%</strong>
          </w-progress>
      </w-toolbar>
    </template>

    <p>
      {{ initiative.short }}
    </p>
    <template #actions>
      <!--
      <w-button v-if="!isVoted" class="mt3 mr1" bg-color="success" type="submit" v-on:click="doVote">Поддерживаю</w-button>
      <w-button v-else class="mt3 mr1" bg-color="secondary" type="submit" v-on:click="doRetract">Передумал</w-button>
      -->
      <router-link v-bind:to="'/initiative/' + initiative.initiativeId">
        <w-button class="mt3 mr1" bg-color="info">Подробнее</w-button>
      </router-link>
    </template>
  </w-card>
</template>

<script>
import {vote, retract} from './util.js';
import {ref} from 'vue';

export default {
  name: 'InitiativeCard',
  props: {
    initiative: Object,
    user: Object
  },
  data() {
		return {
			isVoted: this.vote,
      scoreCopy: this.initiative.score
		}
	},
  setup(props){
    var vote = ref(false);
    for (var voter of props.initiative.votes) {
      if (voter.email == props.user.email) {
        vote = ref(true);
        break;
      }
    }
    return {vote}
  },
  methods: {
    sendVote: async function(f){
      if (!this.user.authorized) {
        this.$waveui.notify('Для голосования нужно войти', 'info');
        return
      }
      var result = await f(this.initiative.initiativeId);
      if (result) {
        this.$waveui.notify('Ваш голос учтен', 'success');
        this.isVoted = !this.isVoted;
      }
      else {
        this.$waveui.notify('Произошла непредвиденная ошибка', 'error');
      }
    },
    doVote: async function(){await this.sendVote(vote);},
    doRetract: async function(){await this.sendVote(retract);},
  },

}
</script>

<style>
.initiative-card {
  max-width: 400px;
  min-width: 300px;
}
a:link { color: black; }
</style>
